module.exports = __webpack_public_path__ + "img/avatar.e6173e63.png";